import React, { useState } from 'react'
import { FiChevronLeft } from 'react-icons/fi'
import '../style/modal.css'
export default function Modal({ children, title, visible, onClose }) {
    const [hide, setHide] = useState(false);

    const handleClose = () => {
        setHide(true);
        setTimeout(() => {
            onClose();
            setHide(false);
        }, 500);
    }
    
    return (
        <>
            {visible &&
                <div className='modal'>
                    <div className={`modal-content ${hide ? 'hide' : ''} flex flex-col gap-4 p-5`}>
                        <div className='flex items-center gap-3 mt-2'>
                            <FiChevronLeft size={24} color='#242323' className='cursor-pointer iconpop' onClick={handleClose} />
                            <p className='title-medium'>{title}</p>
                        </div>
                        <div className='px-2'>
                            {children}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}